import React from 'react';
import PropTypes from 'prop-types';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import { RadioGroup, Select } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import _ from 'underscore';
import { DAILY, WEEKLY, MONTHLY } from './consts';
import { inputTitleStyle } from './styles/input-title-style';

class Frequency extends React.Component {
  constructor(props) {
    super(props);
    const { i18n } = props;
    this.radioValues = [DAILY, WEEKLY, MONTHLY];
    this.getRadioId = (_item, index) => ['daily', 'weekly', 'monthly'][index];
    this.radioOptions = (_item, index) =>
      [
        i18n.getString(_TL_('Daily')),
        i18n.getString(_TL_('Weekly')),
        i18n.getString(_TL_('Monthly')),
      ][index];
  }

  render() {
    const {
      isScheduleEnabled, i18n, CronModel, changeFrequency, cronFormatter, changeHour, classes,
    } = this.props;
    const optionFactory = (selectorName, optionObj, useIndex = true) =>
      _.values(optionObj).map((value, index) => (
        <option key={value} id={`${selectorName}Option-${useIndex ? index : value}`} value={useIndex ? index : value}>
          {value}
        </option>
      ));

    return (
      <React.Fragment>
        <div className={classes.frequencyContainer} role="group" aria-labelledby="freqLabel">
          <div id="freqLabel" className={classes.frequencyTitle}> {i18n.getString(_TL_('Frequency'))}</div>
          <div id="radioContainer" className={classes.radioContainer}>
            <RadioGroup
              disabled={!isScheduleEnabled}
              items={this.radioValues}
              getItemId={this.getRadioId}
              getItemValue={() => CronModel.frequency}
              renderItem={this.radioOptions}
              onChange={frequency => changeFrequency({
                frequency,
                dayOfWeek: frequency === WEEKLY ? '0' : '*',
                dayOfMonth: frequency === MONTHLY ? '1' : '*',
              })}
              checked={CronModel.frequency}
              name="frequencyRadio"
            />
          </div>
          {
            CronModel.frequency === WEEKLY ?
              <div className={classes.frequencySelect}>
                <div id="everyLabel" className={classes.frequencyTitle}>{i18n.getString(_TL_('Every'))}</div>
                <Select
                  disabled={!isScheduleEnabled}
                  id="weeklySelector"
                  value={CronModel.dayOfWeek}
                  onChange={e => changeFrequency({
                    frequency: WEEKLY,
                    dayOfWeek: e.target.value,
                    dayOfMonth: '*',
                  })}
                  aria-labelledby="everyLabel"
                >
                  {optionFactory('weekly', cronFormatter.getDaysOfWeek())}
                </Select>
              </div> : ''
          }
          {
            CronModel.frequency === MONTHLY ?
              <div className={classes.frequencySelect}>
                <div id="onDayLabel" className={classes.frequencyTitle}>{i18n.getString(_TL_('On day'))}</div>
                <Select
                  disabled={!isScheduleEnabled}
                  id="monthlySelector"
                  value={CronModel.dayOfMonth}
                  onChange={e => changeFrequency({
                    frequency: MONTHLY,
                    dayOfWeek: '*',
                    dayOfMonth: e.target.value,
                  })}
                  aria-labelledby="onDayLabel"
                >
                  {optionFactory('monthly', _.omit(cronFormatter.getDaysOfMonth(), '29', '30', '31'), false)}
                </Select>
                <div>{i18n.getString(_TL_('of every month'))}</div>
              </div> : ''
          }
        </div>
        <div className={classes.hourContainer}>
          <div id="atLabel" className={classes.frequencyTitle}> {i18n.getString(_TL_('At'))}</div>
          <Select
            disabled={!isScheduleEnabled}
            id="hourSelector"
            value={CronModel.hour}
            onChange={e => changeHour(e.target.value)}
            aria-labelledby="atLabel"
          >
            {optionFactory('hour', cronFormatter.getHoursOfDay())}
          </Select>
        </div>
      </React.Fragment>);
  }
}

Frequency.propTypes = {
  isScheduleEnabled: PropTypes.bool.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  i18n: ReportingProps.i18n.isRequired,
  CronModel: PropTypes.shape({
    frequency: PropTypes.number,
  }).isRequired,
  changeFrequency: PropTypes.func.isRequired,
  changeHour: PropTypes.func.isRequired,
  cronFormatter: PropTypes.shape({
    getDaysOfWeek: PropTypes.func,
  }).isRequired,
};

const StyledFrequency = withDefaultStyles(Frequency, (components, core) => ({
  frequencyContainer: {
    alignItems: 'center',
    display: 'flex',
    '& .title': {
      alignSelf: 'top',
    },
    '& img': {
      marginRight: '15px',
    },
    '& > div:first-child': {
      top: '-26px',
    },
  },
  frequencyTitle: inputTitleStyle(components, core),
  hourContainer: {
    display: 'flex',
  },
  radioContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: '20px',
  },
  frequencySelect: {
    display: 'flex',
    '& div': {
      flexShrink: 0,
      paddingRight: '5px',
      alignSelf: 'center',
    },
    '& > div:first-child': {
      top: '8px',
    },
  },
}));

export { StyledFrequency as Frequency };
